import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

export const apiaApi: ThemeUICSSObject = {
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  wordBreak: 'break-word',
  overflow: 'hidden',
  width: '100%',

  '.modal__content': {
    overflow: 'hidden',

    '& > div': {
      display: 'flex',
      flexShrink: 1,
      flexDirection: 'column',
      overflow: 'hidden',
    },
  },

  '.handler__form': {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    gap: spacing(6),

    '.toggleAccordionElement': {
      position: 'sticky',
      top: 0,
    },

    '.handler__form__elements': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      overflowY: 'auto',
      maxHeight: '60vh',
      gap: spacing(3),
      pr: spacing(3),
    },

    '.handler__form__elements__section__content': {
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word',
      background: 'palette.background.paper',
      p: 0,
      gap: spacing(3),
    },

    '.content .handler__form__elements__section__content': {
      border: '1px solid',
      borderColor: 'palette.border.section',
      borderTop: 'none',
      p: spacing(6),
    },

    '.handler__form__buttons': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'right',
      p: 0,
      gap: '0px',
      textAlign: 'center',
    },

    '.radio': {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      listStyle: 'none',
      variant: 'layout.execution.form.fields.radio',
    },

    '.handler__checkbox, .handler__radio': {
      'label span': {
        fontWeight: 'normal',
      },
    },

    '.checkbox': {
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'start',
      gap: spacing(4),
      '.semicolon': {
        display: 'none',
      },
      input: {
        width: '100%',
      },
    },

    '.handler__hidden': {
      display: 'none',
    },

    'label.select > div': {
      width: '100%',
    },

    '.spacer': {
      height: spacing(7),
    },
  },
  '.progressBox': {
    p: spacing(5),
    pt: spacing(0),
  },
  /* PREPEND HERE */
};

export default apiaApi;
